// extracted by mini-css-extract-plugin
export default {"root":"Hover_root__tCztP","open":"Hover_open__0S4wd","hover-container":"Hover_hover-container__sWJp-"};